import { createRef, useRef } from 'react';

const useCreateContextRefs = contexts => {
	const contextRefs = useRef(
		contexts.map(({ key }) => key).reduce((acc, key) => ({ ...acc, [key]: createRef() }), {})
	);
	return contextRefs;
};

export default useCreateContextRefs;
